module.exports = __webpack_public_path__ + "img/nav-an-act.c3f621c3.png";